class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  get requiresBodyAppended() {
    return false;
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('cart:grouped-sections', this.getSectionToRender.bind(this));
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartQuantity extends QuantitySelector {
  constructor() {
    super();
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    super.connectedCallback();
    this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
      this.checkQuantityRules.bind(this)
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  checkQuantityRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('[name="minus"]');
      if (buttonMinus) {
        buttonMinus.disabled = parseInt(value) <= parseInt(this.input.min);
      }
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('[name="plus"]');
      if (buttonPlus) {
        buttonPlus.disabled = parseInt(value) >= parseInt(this.input.max);
      }
    }
  }
}

customElements.define('cart-quantity', CartQuantity);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );

    this.cartItemProducts = this.querySelectorAll('.cart-item__product');
    if (this.cartItemProducts) {
      this.cartItemProducts.forEach((cartItemProduct) => {
        const template = cartItemProduct.querySelector('template');
        const templateContent = template && document.importNode(template.content, true);
        const parent = cartItemProduct.querySelector('.cart-item__product--info');
        if (parent && template) {
          parent.appendChild(templateContent);
        }
      });
    }

    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target
    );
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionId = FoxTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(event.cart.sections[sectionId], 'text/html');

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(`#CartDrawerBody-${sectionId}`);
    const cartDrawerFooter = document.querySelector(`#CartDrawerFooter-${sectionId}`);
    const CartDrawerRecommendation = document.querySelector(`#CartDrawerRecommendation-${sectionId}`);
    const cartDrawerEmpty = document.querySelector(`#CartDrawerEmpty-${sectionId}`);
    if (cartDrawer) {
      // const updatedElement = sectionToRender.querySelector(`#CartDrawer-${sectionId}`);
      // if (updatedElement) {
      //   cartDrawer.innerHTML = updatedElement.innerHTML;
      // }
      const cartDrawerBodyUpdate = sectionToRender.querySelector(`#CartDrawerBody-${sectionId}`);
      const cartDrawerFooterUpdate = sectionToRender.querySelector(`#CartDrawerFooter-${sectionId}`);
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(`#CartDrawerEmpty-${sectionId}`);

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }

      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove('hidden');
        cartDrawerFooter.classList.remove('hidden');
        CartDrawerRecommendation.classList.remove('hidden');
        cartDrawerEmpty.classList.add('hidden');
      } else {
        cartDrawerBody.classList.add('hidden');
        cartDrawerFooter.classList.add('hidden');
        CartDrawerRecommendation.classList.add('hidden');
        cartDrawerEmpty.classList.remove('hidden');
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(`#MainCart-${sectionId}`);
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      } else {
        mainCart.closest('.cart').classList.add('is-empty');
        mainCart.remove();
      }
    }

    const lineItem =
      document.getElementById(`CartItem-${event.line}`) || document.getElementById(`CartDrawer-Item-${event.line}`);

    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      FoxTheme.a11y.trapFocus(mainCart || cartDrawer, lineItem.querySelector(`[name="${event.name}"]`));
    } else if (event.cart.item_count === 0) {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('a'))
        : FoxTheme.a11y.trapFocus(document.querySelector('.cart__empty'), document.querySelector('a'));
    } else {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector('.cart-item__title'))
        : FoxTheme.a11y.trapFocus(mainCart, mainCart.querySelector('.cart-item__title'));
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: event.cart,
        },
      })
    );
  }

  updateQuantity(line, quantity, name, target) {
    this.showLoader(line);

    const zip = document.querySelector('[name="address[zip]"]')?.value,
      country = document.querySelector('[name="address[country]"]')?.value,
      province = document.querySelector('[name="address[province]"]')?.value;

    let triggerShippingForm = false;

    if (document.querySelector('[is="shipping-calculator--marginwell"] .product__block--inner--calculate-cost--result')) {
        triggerShippingForm = true;
    }

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        let countItem = parsedState.item_count;
        document.querySelectorAll('.section-show-cart-empty').forEach(item => {
          item.classList.toggle('hidden', countItem > 0)
        });
        document.querySelectorAll('.section-show-has-cart').forEach(item => {
          item.classList.toggle('hidden', countItem <= 0)
        });
        document.querySelectorAll('.cart-total').forEach(item => {
          item.innerHTML = countItem;
        })
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState, target, line, name });
        document.dispatchEvent(new Event('trigger-change-shipping'));
        this.refillCalculateShipping(country, zip, province, triggerShippingForm)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add('btn--loading');
      });
    }
  }

  // Recalculate the shipping
  refillCalculateShipping(country, zip, province, triggerShippingForm = false) {
    document.querySelector('[name="address[zip]"]').value = zip;
    document.querySelector('[name="address[country]"]').value = country;
    document.querySelector('[name="address[province]"]').value = province;

    triggerShippingForm && document.querySelector('[is="shipping-calculator--marginwell"]').dispatchEvent(new Event('submit'), { bubbles: true });
  }
}

customElements.define('cart-items', CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-item', CartRemoveItem, { extends: 'a' });
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.onChange.bind(this), 300));

    if (this.button && this.cartNoteDetailsSummary) {
      this.button.addEventListener('click', () => {
        this.cartNoteDetailsSummary.close();
      });
    }
  }

  get cartNoteDetailsSummary() {
    return this.closest('[is="accordion-details"]');
  }

  get button() {
    return this.querySelector('[type="button"]');
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } });
  }
}
customElements.define('cart-note', CartNote);

class CalculateShipping extends ModalComponent {
  constructor() {
    super();
    this.countryProvince = this.querySelector('country-province');
    this.isCountrySetup = false;
  }
  static get observedAttributes() {
    return [...super.observedAttributes, 'data-show'];
  }
  show() {
    super.show();
    this.setAttribute('data-show', true);
  }

  hide() {
    super.hide();
    this.setAttribute('data-show', false);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === 'data-show' && newValue === 'true' && !this.isCountrySetup && this.countryProvince) {
      const template = this.countryProvince.querySelector('template');
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
}
customElements.define('calculate-shipping', CalculateShipping);
class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));
    if (this.template && this.template === 'cart') {
      this.init();
    }
  }

  init() {
    if (this.getAttribute('country') !== '') {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.dataset.country)
      );
      this.countryElement.dispatchEvent(new Event('change'));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex],
      provinces = JSON.parse(option.dataset.provinces);

    this.provinceElement.closest('.form-field').hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = '';

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
}
customElements.define('country-province', CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add('btn--loading');

    const body = JSON.stringify({
      shipping_address: { zip, country, province },
    });
    let sectionUrl = `${FoxTheme.routes.cart_url}/shipping_rates.json`;

    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove('btn--loading');
      });
  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    
    const wrapper = document.createElement('div');
    wrapper.className = 'gap shipping-result';
    wrapper.innerHTML = `
      <div class="alert alert--error blocks-radius grid gap-2" style="border-radius: 2rem">
        <p class="font-body-bolder m-0">One or more errors occurred while retrieving the shipping rates:</p>
        <ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join('')}</ul>
      </div>
    `;
    
    // Clear existing results and append new wrapper
    this.resultsElement.innerHTML = '';
    this.resultsElement.appendChild(wrapper);
  }

  formatShippingRates(shippingRates) {
    // Filter out "Local Pickup (Auckland)" service
    const filteredRates = shippingRates.filter(rate => 
      rate.presentment_name !== 'Local Pickup (Auckland)'
    );

    if (filteredRates.length === 0) {
      const wrapper = document.createElement('div');
      wrapper.className = 'gap shipping-result';
      wrapper.innerHTML = `<div class="alert alert--error blocks-radius">We couldn't find shipping rates for this postcode. Please double-check the postcode and region.</div>`;
      
      // Clear existing results and append new wrapper
      this.resultsElement.innerHTML = '';
      this.resultsElement.appendChild(wrapper);
      return;
    }

    const formData = new FormData(this);
    const province = formData.get('address[province]') || '';
    const zip = formData.get('address[zip]') || '';
    
    const shippingRatesList = filteredRates.map(({ presentment_name, currency, price }, index) => {
      const checkedAttr = index === 0 ? 'checked' : '';
      return `
        <li>
          <span class="shipping-rate">
            <input name="shipping-rate" type="radio" ${checkedAttr} /> ${presentment_name}
          </span>
          <price data-price="${price}">$${price}</price>
        </li>
      `;
    }).join('');

    const wrapper = document.createElement('div');
    wrapper.className = 'gap shipping-result';
    wrapper.innerHTML = `
      <div class="product__block--inner__title gap">
        <h5>
          Delivery to <span class="provincial-postal--text">${province}, ${zip}</span>
          <a href="javascript:" class="edit-btn">Edit</a>
        </h5>
        <ul class="list-disc grid gap-1 text-sm" role="list">
          ${shippingRatesList}
        </ul>
      </div>
    `;

    // Clear existing results and append new wrapper
    this.resultsElement.innerHTML = '';
    this.resultsElement.appendChild(wrapper);

    // Hide the form fields after showing results
    const countryProvinceElements = this.querySelectorAll('country-province');
    countryProvinceElements.forEach(el => {
      el.style.display = 'none';
    });

    // Add edit button functionality
    this.querySelectorAll('.product__block--inner__title h5 a').forEach(el => {
      el.addEventListener('click', () => { 
        countryProvinceElements.forEach(el => {
          el.style.display = 'block'; 
        });
        
        const existing = this.resultsElement.querySelector('.shipping-result');
        if (existing) existing.remove();
        
        this.resultsElement.innerHTML = '';
      });
    });
    const del_fee_footer_el = document.querySelector('.cart-subtotal.cart-item-price.shipping--price')
    const selected_del_price = parseFloat(document.querySelector('.list-disc li:has(input:checked) price').dataset.price)
    const curr_total_price = parseFloat(document.querySelector('[data-hulkapps-cart-total]').textContent.replaceAll('$', ''))

    document.querySelectorAll('.cart-subtotal.cart-item-price').forEach((el) => {
      el.style.display = 'flex';
    });
    
    del_fee_footer_el.querySelector('.label .shipping-to').textContent = `${province}, ${zip}`
    del_fee_footer_el.querySelector('.price').textContent = `$${selected_del_price.toFixed(2)}`

    document.querySelector('[data-hulkapps-cart-total]').textContent = `$${parseFloat(selected_del_price + curr_total_price).toFixed(2)}`
  }
}
customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });

class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(this.init.bind(this), { timeout: 1500 });
    } else {
      const userAgent = navigator.userAgent;
      const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
      if (isSafari) {
        this.init();
      } else {
        FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '600px 0px 600px 0px' });
      }
    }
  }

  get slideContainer() {
    return this.querySelector('.swiper');
  }

  get sliderPagination() {
    return this.querySelector('.swiper-pagination');
  }

  get sliderNext() {
    return this.querySelector('.swiper-button-next');
  }

  get sliderPrev() {
    return this.querySelector('.swiper-button-prev');
  }

  init() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.shopify-section');

        if (sectionInnerHTML === null) return;

        const recommendations = sectionInnerHTML.querySelector('cart-drawer-products-recommendation');
        if (recommendations && recommendations.innerHTML.trim().length) {
          const productCount = recommendations.querySelectorAll('.product-card');
          this.innerHTML = recommendations.innerHTML;
          this.initCarousel();
          if (productCount.length > 0) this.classList.remove('hidden');
          this.dispatchEvent(new CustomEvent('recommendations:loaded'));
        } else {
          this.closest('.shopify-section').remove();
          this.classList.add('hidden');
          this.dispatchEvent(new CustomEvent('is-empty'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initCarousel() {
    this.carousel = new FoxTheme.Carousel(this.slideContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 1.2,
          spaceBetween: 30,
        },
      },
      pagination: {
        el: this.sliderPagination,
        type: 'fraction',
      },
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
    });

    this.carousel && this.carousel.init();
  }
}

customElements.define('cart-drawer-products-recommendation', CartDrawerProductsRecommendation);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:grouped-sections', this.getSectionToRender.bind(this));
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }
}
customElements.define('main-cart', MainCart);

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      leftToSpend: '[data-left-to-spend]',
      defaultMessage: '.free-shipping-goal__label--default',
      completedMessage: '.free-shipping-goal__label--success',
    };
    this.goal = Number(this.dataset.minimumAmount) * Number(window.Shopify.currency.rate || 1) || 0;
    this.progress = this.querySelector('progress-bar');
    this.money_format = window.FoxTheme.settings.moneyFormat;
  }

  connectedCallback() {
    this.updateShippingGloal(Number(this.dataset.cartTotal));
    document.addEventListener('cart:updated', (event) => {
      // !This is the original line, but we need total price. Because subtotal does not include discounts.
      // this.updateShippingGloal(event.detail.cart.items_subtotal_price); 

      this.updateShippingGloal(event.detail.cart.total_price);
    });
  }

  updateShippingGloal(amount) {
    if (amount > 0) {
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }

    this.convertedAmount = amount / 100;
    this.miniCartPromoData = window.cart_promo_data // Fetches the promo data from the global variable on theme.liquid
    this.highestPromoGoal = Math.max(...this.miniCartPromoData.map(o => o.tier_goal)) // Gets highest Promo Goal
    this.getTierValue = this.miniCartPromoData.filter(promo => promo.tier_goal >= this.convertedAmount) // This gets all the remaining tiers that haven't been reached yet
    this.finalTierValue = (this.getTierValue.length <= 0) ? this.miniCartPromoData.filter(promo => promo.tier_goal == this.highestPromoGoal) : this.getTierValue // this checks if there are any remaining tiers, if not it will return the highest tier value
    this.computePercentage = ((this.convertedAmount/this.finalTierValue[0].tier_goal) > 1) ? 100 : (this.convertedAmount/this.finalTierValue[0].tier_goal)*100 // Computes the percentage left from total cart to next current goal
    this.remainingSpend = this.finalTierValue[0].tier_goal - this.convertedAmount // This is the actual difference in amount between the current cart total and the next goal

    // promo messages
    this.defaultMessage = `Spend $${ this.remainingSpend.toFixed(2) } more, to get ${ this.finalTierValue[0].tier_discount }`
    this.completedGoals = `You have reached required spending for all tiers!`
    
    if (this.computePercentage >= 100) {
      this.querySelector(this.selectors.completedMessage).innerHTML = this.completedGoals;
      this.classList.add('free-shipping-goal--done');
      
      // Progress bar is set like this because it has it's own class and this is the data it needs to display correctly
      this.progress.style.setProperty('--percent', `100%`);
      this.progress.dataset.value = this.convertedAmount;
      this.progress.dataset.max = this.finalTierValue[0].tier_goal;
    } else {
      this.querySelector(this.selectors.defaultMessage).innerHTML = this.defaultMessage;
      this.classList.remove('free-shipping-goal--done');

      // Progress bar is set like this because it has it's own class and this is the data it needs to display correctly
      this.progress.style.setProperty('--percent', `${this.computePercentage}%`);
      this.progress.dataset.value = this.convertedAmount;
      this.progress.dataset.max = this.finalTierValue[0].tier_goal;
    }


    // !This was the original code, but it could only handle one goal at a time.
    // this.cartTotal = amount / 100;
    // this.goalLeft = this.goal - this.cartTotal;
    // this.goalDone = this.goalLeft <= 0;

    // this.percent = (this.cartTotal * 100) / this.goal;

    // if (this.percent >= 100) this.percent = 100;

    // if (this.cartTotal >= this.goal) {
    //   this.progress.style.setProperty('--percent', `${this.percent}%`);
    //   this.classList.add('free-shipping-goal--done');
    //   this.progress.dataset.value = this.cartTotal;
    //   this.progress.dataset.max = this.goal;
    // } else {
    //   let spend = (this.goal - this.cartTotal) * 100;
    //   this.querySelector(this.selectors.leftToSpend).innerHTML = FoxTheme.Currency.formatMoney(
    //     spend,
    //     this.money_format
    //   );
    //   this.classList.remove('free-shipping-goal--done');
    //   this.progress.style.setProperty('--percent', `${this.percent}%`);
    //   this.progress.dataset.value = this.cartTotal;
    //   this.progress.dataset.max = this.goal;
    // }
  }
}
customElements.define('free-shipping-goal', FreeShippingGoal);

window.FoxKitAddToCart = async (payload) => {
  if (!payload?.properties?.['_FoxKit offer']) return;

  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson['sections'] = payload['sections'];
  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

  document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: payload,
      },
    })
  );
};

class CartAccordionDetails extends AccordionDetails {
  constructor() {
    super();
    this.initCartAccordion();
  }

  initCartAccordion() {
    // Check if we're on cart page and restore state if needed
    if (this.isCartPage()) {
      this.restoreState();
    }
  }

  isCartPage() {
    return window.location.pathname.includes('/cart') || document.body.classList.contains('cart-template');
  }

  // State persistence methods
  restoreState() {
    if (FoxTheme.config.hassessionStorage) {
      const accordionId = this.id || this.getAttribute('data-accordion-id') || this.generateAccordionId();
      if (accordionId) {
        const storageKey = this.getStorageKey(accordionId);
        const savedState = FoxTheme.utils.getStorage(storageKey);
        if (savedState !== null) {
          this.isOpen = savedState;
          if (this.isOpen) {
            this.setAttribute('open', '');
          } else {
            this.removeAttribute('open');
          }
        }
      }
    }
  }

  generateAccordionId() {
    const section = this.closest('.shopify-section');
    const sectionId = section ? section.id.replace('shopify-section-', '') : 'unknown';
    const position = this.offsetTop || 0;
    const content = this.textContent?.trim().substring(0, 20) || '';
    return `${sectionId}-${position}-${content.replace(/\s+/g, '-')}`;
  }

  getStorageKey(accordionId) {
    return `cart-accordion-${accordionId}`;
  }

  saveState() {
    if (FoxTheme.config.hassessionStorage && this.isCartPage()) {
      const accordionId = this.id || this.getAttribute('data-accordion-id') || this.generateAccordionId();
      if (accordionId) {
        const storageKey = this.getStorageKey(accordionId);
        FoxTheme.utils.setStorage(storageKey, this.isOpen, 1);
      }
    }
  }

  // Override the toggleAccordion method to save state on cart page
  toggleAccordion(event) {
    event.preventDefault();
    this.open = !this.open;
    
    // Save state if on cart page
    if (this.isCartPage()) {
      this.saveState();
    }
  }
}

customElements.define('cart-accordion-details', CartAccordionDetails, { extends: 'details' });